const destination = {
  props: {
    destinationSelector: "destination-JS",
    popoverClassName: "c-popover__content-block",
    popoverNoSearchClassName: "c-popover__content-JS",
    submenuDestination: "c-fastbooking__submenu-destination",
    submenuSearch: "c-fastbooking__submenu-search",
    submenuSearchJS: "fastbooking__submenu-search-JS",
    itemsOnFasbookingResults: "c-fastbooking__submenu-search-destination-barcelo-hotel-list-JS li",
    submenuDestinationFields: {
      history: "c-fastbooking__submenu-destination-history",
      noSearch: "c-fastbooking__submenu-destination-no-search .value-no-search-JS",
      allDestinationSelector: "all-destination-JS",
      hotelsSelector: "destination-hotels-JS",
    },
    resorts: [],
    $submenuDestinationFields: {
      history: null,
      noSearch: null,
      allDestinations: null,
      hotels: null,
    },
    submenuSearchFields: {
      destination: "c-fastbooking__submenu-search-hotels",
      hotel: "c-fastbooking__submenu-search-destination",
      destinationElementInHotelSelector: "destination-selected-hotels-JS",
      ownHotelsListClass: "c-fastbooking__submenu-search-destination-barcelo-hotel-list-JS",
    },
    $submenuSearchFields: {
      hotel: null,
      destination: null,
    },
    $onlyExternalBrandHotelsMessageBox: null,
    $externalBrandHotelsSubmenuHeader: null,
    lastSearch: {
      hotelNameSelector: "history__hotel-name",
      placeNameSelector: "history__hotel-direction",
      adultsSelector: "adults-number-JS",
      childrenSelector: "children-number-JS",
      datesSelector: "dates-JS",
      showDestinationSelector: "show-destination-JS",
    },
    lastSearchSelector: "lastSearch-JS",
    titleLastSearchSelector: "title-lastSearch-JS",
    titleDestinationDestSelector: "title-destinationDest-JS",
    suggestionsSelector: "suggestions-JS",
    $destinationInput: null,
    $destinationContainer: null,
    $searchContainer: null,
    maxResults: 10,
    used: false,
    data: null,
    dateOptions: { month: "short" },
    tooltipSelector: "c-fastbooking__submenu-destination-tooltip",
    showTooltip: false,
    classLoading: "mod--loading-dots",
    elementIndexWithPercentageFound: 0,
    elementIndexFlagManualSelected: null,
    elementWithPercentageFound: null,
    elementWithPercentageFoundSelector: "element-with-percentage-found-JS",
    elementIndexWithHoverSelector: "mod--background-light-blue element-with-percentage-found-JS",
    percentageToClick: 80,
    accordionNodeCloned: null,
    accordionDefaultParentValue: "firstLevel",
    accordionLabelClass: "accordion-label-JS",
    accordionItemClass: "accordion-item-JS",
    filters: {
      countContainerSelector: "filter-count-JS",
      numberSelector: "filter-number-JS",
    },
    globalHotelComparatorUrl: "global-hotel-comparator-url-JS",
    isSubmenuDestinationContainer: false,
    totalOfHotels: 0,
    urlResort: null,
    $ownHotelList: null,
    order1: "order-1",
    order2: "order-2",
    orderNone: "md:order-none",
    destinationContainerSelector: ".mod--destination",
    showDeleteBtnClass: "mod--active-delete",
  },

  init: function () {
    if (bcl.c.fastbooking.disabled) {
      delete bcl.c.fastbooking.destination;
      return;
    }

    const $element = bcl.c.fastbooking.commonProps.fastbooking.$container,
      $destinationInput = this.searchNode($element, "destinationSelector");

    if (!$destinationInput) {
      return;
    }

    this.props.urlHomeResort = document.body.dataset.homeresort;
    bcl.c.fastbooking.commonProps.destination.url = bcl.c.fastbooking.commonProps.fastbooking.url.replace("json", "bcldata.json");
    this.props.urlResort = bcl.c.fastbooking.commonProps.fastbooking.url.replace("json", "bcldata.resorts.json");

    bcl.c.fastbooking.commonProps.destination.$destinationInput = $destinationInput;

    this.props.maxResults = parseInt($destinationInput.dataset.numbermaxresults);

    this.initNodes();

    this.initLastSearches();
    this.initSuggestions();
    this.initListener($element);
  },

  initLastSearches: function () {
    const $ul = this.searchNode(this.props.$destinationContainer, "lastSearchSelector");

    if (!$ul) {
      return;
    }

    this.props.templateLastSearch = $ul.innerHTML;

    this.props.$lastSearch = $ul;

    this.props.$lastSearch.innerHTML = "";

    const $buttonShowHotel = $ul.parentNode?.querySelector("." + this.props.lastSearch.showDestinationSelector);
    $buttonShowHotel?.addEventListener("click", this.showDestination.bind(this));

    this.loadLastSearch($buttonShowHotel);
  },

  initFacets: function () {
    const popoversHotels = document.querySelectorAll(".filter-facet-JS");
    if (popoversHotels.length > 0) {
      bcl.u.forEach(popoversHotels, (popoverHotels) => {
        const popover = popoverHotels.closest(".c-popover__content");
        if (bcl.u.containsClass(popover, "mod--active")) {
          this.props.nodeHotels = popoverHotels;
          this.props.nodePopover = popover;
        }
      });
    }

    if (this.props.nodePopover) {
      const facetNodeList = this.props.nodePopover.querySelectorAll(".facet-JS");
      bcl.u.forEach(facetNodeList, (facetNode) => {
        this.props.facetActive = false;
        bcl.u.addClass(facetNode, "mod--cta-disabled");
        if (bcl.u.containsClass(facetNode, "mod--active")) {
          this.props.facetActive = true;
          bcl.u.removeClass(facetNode, "mod--active");
        }
        facetNode.removeEventListener("click", this.clickInFacet.bind(this));
        const facet = facetNode.dataset.facet,
          hotelsFacet = this.props.nodeHotels.querySelectorAll('li:not(.hidden)[data-facets*="' + facet + '"]');
        if (hotelsFacet && hotelsFacet.length > 0) {
          bcl.u.removeClass(facetNode, "mod--cta-disabled");
          if (this.props.facetActive) {
            bcl.u.addClass(facetNode, "mod--active");
          }
          facetNode.addEventListener("click", this.clickInFacet.bind(this));
        }
      });
    }

    this.showOrHideHotels(false);
  },

  clickInFacet: function (e) {
    if (bcl.u.containsClass(e.currentTarget, "mod--active")) {
      bcl.u.removeClass(e.currentTarget, "mod--active");
    } else {
      bcl.u.addClass(e.currentTarget, "mod--active");
    }
    this.showOrHideHotels(true);
  },

  showOrHideHotels: function (clickInFacet) {
    if (!bcl.c.fastbooking.destination.props.nodeHotels || !bcl.c.fastbooking.destination.props.nodePopover) {
      return;
    }

    let firstPartQuery = "li.hidden-facet-JS",
      secondPartQuery = "",
      separator = "";

    const hotelsHiddenFacets = this.props.nodeHotels.querySelectorAll(firstPartQuery),
      destinationElementInHotelList = this.props.nodeHotels.querySelector("." + this.props.submenuSearchFields.destinationElementInHotelSelector);

    bcl.u.forEach(hotelsHiddenFacets, function (hotel) {
      if (clickInFacet) {
        bcl.u.removeClass(hotel, "hidden");
        bcl.u.removeClass(hotel, "hidden-facet-JS");
      } else {
        bcl.u.removeClass(hotel, "hidden-facet-JS");
      }
    });

    const hotels = this.props.nodeHotels.querySelectorAll('li:not(.hidden):not([data-facets="undefined"]):not(.' + this.props.globalHotelComparatorUrl + ")");
    bcl.u.forEach(hotels, function (hotel) {
      bcl.u.addClass(hotel, "hidden hidden-facet-JS");
    });

    const facetNodeList = this.props.nodePopover.querySelectorAll(".facet-JS.mod--active");
    if (facetNodeList.length > 0) {
      separator = ", ";
      secondPartQuery = "li.hidden-facet-JS";
    }

    bcl.u.forEach(facetNodeList, function (facetNode) {
      const facet = facetNode.dataset.facet;
      firstPartQuery += '[data-facets*=",' + facet + '"]';
      secondPartQuery += '[data-facets*="' + facet + ',"]';
    });

    const hotelsFacet = this.props.nodeHotels.querySelectorAll(firstPartQuery + separator + secondPartQuery);
    bcl.u.forEach(hotelsFacet, function (hotelFacet) {
      bcl.u.removeClass(hotelFacet, "hidden");
    });

    const hotelCountContainer = destinationElementInHotelList?.querySelector(".hotels-count-JS");

    if (hotelCountContainer) {
      const hotelLabel = hotelCountContainer.innerText.split(" ")[1];
      hotelCountContainer.innerText = hotelsFacet.length + " " + hotelLabel;
    }

    const filterContainer = destinationElementInHotelList?.querySelector("." + this.props.filters.countContainerSelector),
      filterNumber = filterContainer?.querySelector("." + this.props.filters.numberSelector);

    if (filterNumber) {
      filterNumber.innerText = facetNodeList.length;
    }

    facetNodeList.length > 0 && filterContainer && bcl.u.addClass(filterContainer, "md:inline-block");
    facetNodeList.length <= 0 && filterContainer && bcl.u.removeClass(filterContainer, "md:inline-block");
  },

  loadLastSearch: function ($buttonShowHotel) {
    let data = localStorage.getItem(bcl.c.fastbooking.commonProps.fastbooking.attributes.localStorage);

    if (!data) {
      return;
    }

    if ($buttonShowHotel) {
      bcl.u.removeClass($buttonShowHotel, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
      const $lastSearchContainer = $buttonShowHotel.parentNode?.querySelector(" ." + this.props.lastSearchSelector);
      $lastSearchContainer && bcl.u.removeClass($lastSearchContainer, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    }

    this.props.$lastSearch.innerHTML = "";

    const $title = this.searchNode(this.props.$destinationContainer, "titleLastSearchSelector");

    bcl.u.removeClass($title, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

    data = JSON.parse(data);
    bcl.c.fastbooking.commonProps.fastbooking.lastSearchData = data;

    for (let i = data.length - 1; i >= 0; i--) {
      this.initItemLastSearch(data[i]);
    }

    if (!bcl.c.fastbooking.commonProps.destination.$destinationInput.value && bcl.c.fastbooking.commonProps.calendar.data?.startDate && data?.at(-1)?.destination?.label) {
      bcl.c.fastbooking.commonProps.destination.$destinationInput.value = data.at(-1).destination.label;
    }
  },

  initItemLastSearch: function (item) {
    const $newItem = document.createElement("li");

    $newItem.setAttribute("role", "button");

    $newItem.innerHTML = this.props.templateLastSearch;

    this.setPropInLastSearch($newItem, "hotelNameSelector", item.destination.label);
    item.destination?.countryData && this.setPropInLastSearch($newItem, "placeNameSelector", this.constructDestinationLabel(item.destination.countryData));
    this.setPropInLastSearch($newItem, "datesSelector", this.getDates(item));
    this.setPropInLastSearch($newItem, "adultsSelector", this.getCount(item.rooms.adults));

    this.setPropInLastSearch($newItem, "childrenSelector", this.getChildren(item.rooms.children), true);

    this.props.$lastSearch.appendChild($newItem);

    $newItem.addEventListener("click", function () {
      bcl.c.fastbooking.activeLastSearch(item);
    });
  },

  constructDestinationLabel: function ({ countryName, parentDestinationName }) {
    return countryName && parentDestinationName ? `${parentDestinationName} (${countryName})` : null;
  },

  getCount: function (items) {
    let count = 0;

    for (const element of items) {
      count += parseInt(element);
    }

    return count;
  },

  getChildren: function (children) {
    let count = 0;

    for (const element of children) {
      // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
      for (const element2 of element) {
        count++;
      }
    }

    return count;
  },

  getDates: function (item) {
    if (!item.calendar.startDate || !item.calendar.endDate) {
      return null;
    }

    const startDate = new Date(item.calendar.startDate),
      endDate = new Date(item.calendar.endDate),
      startMonth = this.getMonth(startDate),
      endMonth = this.getMonth(endDate);

    let dates = startDate.getDate();

    if (startMonth != endMonth) {
      dates += " " + startMonth;
    }

    return dates + " - " + endDate.getDate() + " " + endMonth.toUpperCase() + " ·";
  },

  getMonth: function (date) {
    return date.toLocaleDateString(bcl.c.fastbooking.commonProps.calendar.location, this.props.dateOptions);
  },

  setPropInLastSearch: function ($node, selector, value, hidden) {
    const $element = $node.querySelector("." + this.props.lastSearch[selector]);

    if ($element) {
      $element.innerText = value;
    }

    if ($element && hidden && bcl.c?.fastbooking?.commonProps?.fastbooking?.hiddenClass && !value) {
      bcl.u.addClass($element.parentNode, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    }
  },

  getIndexOfElement: function () {
    return this.props.elementIndexFlagManualSelected || this.props.elementIndexFlagManualSelected === 0 ? this.props.elementIndexFlagManualSelected : this.props.elementIndexWithPercentageFound;
  },

  isTheCorrectElement: function (submenuSearch) {
    return submenuSearch[this.getIndexOfElement()] === document.querySelectorAll("." + this.props.submenuSearchJS + " li[data-percentage-match].element-with-percentage-found-JS")[0];
  },

  setBackgroundColorLikeHover: function (submenuSearch, needSearchIndex) {
    const currentElement = needSearchIndex ? submenuSearch[this.getIndexOfElement()] : submenuSearch;
    bcl.u.addClass(currentElement, this.props.elementIndexWithHoverSelector);
  },

  cleanBackgroundClass: function ($element) {
    bcl.u.containsClass($element, this.props.elementWithPercentageFoundSelector) && bcl.u.removeClass($element, "mod--background-light-blue");
    bcl.u.removeClass($element, "mod--hover-grey");
    bcl.u.removeClass($element, "element-with-percentage-found-JS");
  },

  cleanAllElementWithHoverClass: function (submenuSearch) {
    bcl.u.forEach(submenuSearch, ($element) => {
      this.cleanBackgroundClass($element);
    });
  },

  changeIndexOfElement: function (operation, submenuSearch) {
    let indexToReturn = 0;
    if (this.isTheCorrectElement(submenuSearch)) {
      indexToReturn = operation === "plus" ? this.props.elementIndexFlagManualSelected + 1 : this.props.elementIndexFlagManualSelected - 1;
    }

    return indexToReturn;
  },

  setElementIndexFlagManualSelected: function (operation, submenuSearch) {
    let elementIndexValue;

    if (operation === "plus") {
      elementIndexValue = this.props.elementIndexFlagManualSelected > submenuSearch.length - 1 ? 0 : this.props.elementIndexFlagManualSelected;
    } else {
      elementIndexValue = this.props.elementIndexFlagManualSelected < 0 ? submenuSearch.length - 1 : this.props.elementIndexFlagManualSelected;
    }

    this.props.elementIndexFlagManualSelected = elementIndexValue;
  },

  searchElementWithPercentage: function (submenuSearch) {
    this.props.elementIndexWithPercentageFound = 0;
    for (let i = 0; i < submenuSearch.length; i++) {
      if (parseInt(submenuSearch[i].dataset.percentageMatch) >= this.props.percentageToClick) {
        this.props.elementIndexWithPercentageFound = i;
        return true;
      }
    }
    return false;
  },

  clickOnElementWithPercentage: function (submenuSearch) {
    bcl.u.triggerEvent(submenuSearch[this.props.elementIndexWithPercentageFound], "click");
  },

  selectDestinationOnPressKey: function (e) {
    const submenuSearch = document.querySelectorAll("." + this.props.submenuSearchJS + " li[data-percentage-match]:not(.hidden)"),
      found = this.searchElementWithPercentage(submenuSearch);

    this.setBackgroundColorLikeHover(submenuSearch, true);

    if (e.key === "Enter" && submenuSearch.length > 0) {
      document.activeElement.blur();
      this.props.elementIndexWithPercentageFound = !found ? 0 : this.getIndexOfElement();

      this.clickOnElementWithPercentage(submenuSearch);
    }

    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      this.props.elementIndexFlagManualSelected = this.getIndexOfElement() > submenuSearch.length - 1 ? 0 : this.getIndexOfElement();
    }

    if (e.key === "ArrowUp" && submenuSearch.length > 0) {
      this.props.elementIndexFlagManualSelected = this.changeIndexOfElement("less", submenuSearch);
      this.setElementIndexFlagManualSelected("less", submenuSearch);
    }

    if (e.key === "ArrowDown" && submenuSearch.length > 0) {
      this.props.elementIndexFlagManualSelected = this.changeIndexOfElement("plus", submenuSearch);
      this.setElementIndexFlagManualSelected("plus", submenuSearch);
    }

    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      this.cleanAllElementWithHoverClass(submenuSearch);
      this.setBackgroundColorLikeHover(submenuSearch, true);
    }

    return false;
  },

  selectFirstItemWithMoreMatch: function () {
    setTimeout(function () {
      const allItemsOnList = document.querySelectorAll("." + bcl.c.fastbooking.destination.props.itemsOnFasbookingResults);
      if (allItemsOnList && allItemsOnList.length > 0) {
        let founded = false;

        bcl.u.forEach(allItemsOnList, function ($item) {
          const currentMathValue = $item.dataset.percentageMatch;
          if (currentMathValue >= bcl.c.fastbooking.destination.props.percentageToClick && !founded) {
            bcl.c.fastbooking.destination.setBackgroundColorLikeHover($item, false);
            founded = true;
          }
        });
      }
    }, 1000);
  },

  processGeneralRequest: function () {
    const url = bcl.u.includes(bcl.c.fastbooking.commonProps.destination.url, ".json") ? bcl.c.fastbooking.commonProps.destination.url.replace(".json", ".dest.html") : bcl.c.fastbooking.commonProps.destination.url;
    this.props.isSubmenuDestinationContainer = true;
    bcl.u.addBhgLoading(this.props.$destinationContainer, true);
    bcl.ajax.getRequest(null, url, this.destinationCallback.bind(this));
  },

  processGeneralRequestResort: function () {
    this.props.isSubmenuDestinationContainer = true;
    bcl.u.addBhgLoading(this.props.$destinationContainer);
    bcl.ajax.postRequest({
      data: { homeResortPath: this.props.urlHomeResort },
      url: this.props.urlResort,
      callback: this.destinationCallback.bind(this),
    });
  },
  isClosed: function () {
    return bcl.s?.tabs?.containerActive || bcl.s?.tabs?.props?.$lastTab != bcl.c.fastbooking.commonProps.destination.$destinationInput;
  },
  initListener: function ($element) {
    const $destinationInput = bcl.c.fastbooking.commonProps.destination.$destinationInput;
    if (!$destinationInput) {
      return;
    }
    let typingTimer;
    let fromDestinationKeyUp = false;
    $destinationInput.addEventListener("keyup", (e) => {
      if (!fromDestinationKeyUp) {
        return;
      }
      fromDestinationKeyUp = false;
      if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "Tab" || e.key === "Shift" || (e.key === "Tab" && e.shiftKey)) {
        return;
      }
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        if (!bcl.s.tabs.containerActive || bcl.s.tabs.props?.$lastTab != $destinationInput) {
          if (this.isClosed()) {
            //Trigger custon event to open de destination pop up on keyup without activating the general request 'click' event
            bcl.u.triggerEvent($destinationInput, "open-destination");
          }
        }
        this.destinationEvent($destinationInput);
        this.selectFirstItemWithMoreMatch();
      }, 500);
    });
    $destinationInput.addEventListener("focusout", () => {
      fromDestinationKeyUp = false;
    });
    $destinationInput.addEventListener("keydown", (e) => {
      fromDestinationKeyUp = true;
      clearTimeout(typingTimer);
      this.selectDestinationOnPressKey(e);
    });
    let loadedData = false; // PLASOFT-21696: Fix for the initial loading of destinations in P&T
    $destinationInput.addEventListener("click", () => {
      if (loadedData && !this.isClosed()) {
        // PLASOFT-21696: after beign opened, the destination input should not trigger the request again
        return;
      }
      loadedData = true;
      if (this.props.urlHomeResort) {
        this.processGeneralRequestResort();
      } else {
        this.processGeneralRequest();
      }
      this.hideOrShowDestination();
      if (bcl.u.mobile.isMobile()) {
        this.toggleRemoveScrollingClass("addClass");
        !document.querySelector(".bpt-fastbooking") && bcl.u.mobile.iOS() && bcl.u.goToWithScroll();
      }
    });

    const $destinationContainer = $element.querySelector(this.props.destinationContainerSelector);
    if ($destinationContainer && $destinationInput) {
      $destinationInput.addEventListener(
        "focusout",
        function () {
          $destinationContainer.classList[$destinationInput.value ? "add" : "remove"](this.props.showDeleteBtnClass);
        }.bind(this),
      );
    }
  },

  toggleRemoveScrollingClass: function (action) {
    const body = document.querySelector("body"),
      html = document.querySelector("html");

    bcl.u[action](body, "removeScrolling");
    bcl.u[action](html, "removeScrolling");
  },

  initNodes: function () {
    this.initSearchNodes();
    this.initDestinationNodes();
  },

  initSearchNodes: function () {
    const $element = bcl.c.fastbooking.commonProps.fastbooking.$container,
      $searchContainer = this.searchNode($element, "submenuSearch");

    if (!$searchContainer) {
      return;
    }

    this.props.$searchContainer = $searchContainer;

    this.props.$submenuSearchFields.hotel = $searchContainer.querySelector("." + this.props.submenuSearchFields.hotel + " ul");

    this.props.$submenuSearchFields.destination = $searchContainer.querySelector("." + this.props.submenuSearchFields.destination + " ul");

    this.props.$ownHotelList = $searchContainer.querySelector("." + this.props.submenuSearchFields.ownHotelsListClass);

    this.props.hotelsLabel = this.props.$submenuSearchFields.destination.parentNode.dataset.hotels || bcl.c.fastbooking.commonProps.fastbooking.$container.dataset.i18nHotels;
  },

  initDestinationNodes: function () {
    const $element = bcl.c.fastbooking.commonProps.fastbooking.$container,
      $destinationContainer = this.searchNode($element, "submenuDestination");

    if (!$destinationContainer) {
      return;
    }

    this.props.$destinationContainer = $destinationContainer;

    this.props.$submenuDestinationFields.history = $destinationContainer.querySelector("." + this.props.submenuDestinationFields.history + " ." + this.props.lastSearchSelector);

    this.props.$submenuDestinationFields.noSearch = $destinationContainer.querySelectorAll("." + this.props.submenuDestinationFields.noSearch);

    this.props.$submenuDestinationFields.allDestinations = $destinationContainer.querySelector("." + this.props.submenuDestinationFields.allDestinationSelector);

    this.props.$submenuDestinationFields.hotels = $destinationContainer.querySelector("." + this.props.submenuDestinationFields.hotelsSelector);
  },

  showTooltip: function () {
    const $tooltips = this.props.$destinationContainer.querySelectorAll("." + this.props.tooltipSelector);
    bcl.u.forEach($tooltips, function ($tooltip) {
      bcl.u.removeClass($tooltip, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    });
  },
  hideTooltip: function () {
    const $tooltips = this.props.$destinationContainer.querySelectorAll("." + this.props.tooltipSelector);
    bcl.u.forEach($tooltips, function ($tooltip) {
      bcl.u.addClass($tooltip, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    });
  },

  searchNode: function ($parent, selector) {
    selector = this.props[selector] || selector;

    const $node = $parent.getElementsByClassName(selector);

    if (!$node?.[0]) {
      return;
    }

    return $node[0];
  },

  getInputValue: function ($destinationInput) {
    if (!$destinationInput) {
      return;
    }

    let inputValue = $destinationInput.value,
      finalWorld = "";

    const wordsInValue = inputValue.split(/(\s+)/);

    if (wordsInValue && wordsInValue.length > 0) {
      for (const element of wordsInValue) {
        const worldToLowerCase = element.toLowerCase();
        finalWorld += worldToLowerCase === "barcelo" ? "Barceló" : element;
      }
    }

    inputValue = finalWorld ? finalWorld : inputValue;
    $destinationInput.value = inputValue;

    return inputValue;
  },

  destinationEvent: function ($destinationInput) {
    const $element = bcl.c.fastbooking.commonProps.fastbooking.$container;
    let $url = "";

    if ($destinationInput.value.length >= $element.dataset.fbsearchlimit) {
      bcl.u.addClass(this.props.$destinationInput, this.props.classLoading);
      this.props.isSubmenuDestinationContainer = false;

      const inputValue = this.getInputValue($destinationInput);

      if (this.props.urlHomeResort) {
        $url = this.props.urlResort;
      } else {
        $url = bcl.c.fastbooking.commonProps.destination.url;
      }
      bcl.u.addBhgLoading(this.props.$searchContainer, true);
      bcl.ajax.postRequest({
        data: { q: inputValue, homeResortPath: this.props.urlHomeResort },
        url: $url,
        callback: this.destinationCallback.bind(this),
        itemCallback: $destinationInput.value,
      });
    } else {
      bcl.c.fastbooking.commonProps.destination.data = null;
      bcl.c.fastbooking.commonProps.destination.lastLabel = null;
      if (this.props.urlHomeResort) {
        this.processGeneralRequestResort();
      } else {
        this.processGeneralRequest();
      }
      this.hideOrShowDestination();
      this.changeContainer("submenuDestination");
    }
  },

  destinationCallback: function (response, value) {
    bcl.u.removeClass(bcl.c.fastbooking.commonProps.destination.$destinationInput, this.props.classLoading);

    const obj = JSON.parse(response.response);
    this.hideItemsSearch();

    bcl.c.fastbooking.commonProps.destination.data = null;
    bcl.c.fastbooking.commonProps.destination.lastLabel = null;

    if ((!obj.unifiedResults || obj.unifiedResults.length === 0) && (!obj.results || obj.results.length === 0)) {
      this.hideOrShowDestination(true);
      this.changeContainer("submenuDestination");
      return;
    }

    //Print Hotels
    const $listHotels = this.props.isSubmenuDestinationContainer ? this.props.$submenuDestinationFields.hotels : this.props.$submenuSearchFields["hotel"];
    const $listDestination = this.props.isSubmenuDestinationContainer ? this.props.$submenuDestinationFields.allDestinations : this.props.$submenuSearchFields["destination"];
    const results = obj.unifiedResults && obj.unifiedResults.length > 0 ? obj.unifiedResults : obj.results;
    this.props.resorts = obj.resorts;
    this.destinationPrint(results, "destination", value, $listHotels);

    if (!this.props.isSubmenuDestinationContainer) {
      this.changeContainer("submenuSearch");
      bcl.u.removeBhgLoading(this.props.$searchContainer);
    }

    if (this.props.isSubmenuDestinationContainer) {
      this.changeContainer("submenuDestination");

      const linkComparator = this.props.$destinationContainer.querySelector("." + this.props.globalHotelComparatorUrl),
        clonedLink = linkComparator?.cloneNode(true);

      !bcl.u.mobile.isMobile() && clonedLink && bcl.u.removeClass(clonedLink, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

      !bcl.u.mobile.isMobile() && clonedLink && this.props.$submenuDestinationFields.hotels?.insertBefore(clonedLink, this.props.$submenuDestinationFields.hotels.firstElementChild);

      if (bcl.s?.translateOnTheFly?.hasToTranslate()) {
        const container = document.querySelector("." + this.props.submenuDestination);
        if (container) {
          setTimeout(() => {
            bcl.s.translateOnTheFly?.handleNodeTranslation(container);
          }, 500);
        }
      } else {
        bcl.u.removeBhgLoading(this.props.$destinationContainer);
      }
    }

    bcl.s.tabs.cleanAndSetStylePopFbDialog(this.props.$containerActive);
    bcl.c.fastbooking.calendar.showOrHideRelateds();
    this.sortResultBlocks(results, $listHotels, $listDestination);
    this.initFacets();
  },
  sortResultBlocks: function (results, $listHotels, $listDestination) {
    const $hotelsPopover = $listHotels.closest("." + this.props.popoverClassName);
    const $destinationsPopover = $listDestination.closest("." + this.props.popoverClassName);
    if (bcl.u.mobile.isMobile()) {
      if (results.length > 2) {
        bcl.u.addClass($hotelsPopover, this.props.order1);
        bcl.u.addClass($destinationsPopover, this.props.order2);
        bcl.u.removeClass($hotelsPopover, this.props.order2);
        bcl.u.removeClass($destinationsPopover, this.props.order1);
      } else {
        bcl.u.addClass($hotelsPopover, this.props.order2);
        bcl.u.addClass($destinationsPopover, this.props.order1);
        bcl.u.removeClass($hotelsPopover, this.props.order1);
        bcl.u.removeClass($destinationsPopover, this.props.order2);
      }
    }
  },
  changeContainer: function (selector) {
    const className = this.props[selector];

    if (this.props.containerActive === className) {
      return;
    }
    this.props.containerActive = className;
    bcl.s.tabs.changeContainerWithEqualTab(className);

    this.props.$containerActive = bcl.s.tabs.props.$containerActive;

    if (!this.props.$containerActive) {
      return;
    }

    this.props.$containerActive.querySelectorAll(".cmp-image .cmp-image__image--is-loading")?.forEach(function (e) {
      e.dispatchEvent(new Event("cmp-image-redraw"));
    });
  },

  hideItemsSearch: function () {
    for (const key in this.props.$submenuSearchFields) {
      bcl.u.addClass(this.props.$submenuSearchFields[key].closest("." + this.props.popoverClassName), bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    }
  },

  removeClassElement: function ($element) {
    bcl.u.removeClass($element.closest("." + this.props.popoverClassName), bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
  },

  insertTextOnElement: function ($element) {
    $element.innerText = '"' + bcl.c.fastbooking.commonProps.destination.$destinationInput.value + '"';
  },

  addClassOnElement: function ($element) {
    bcl.u.addClass($element.closest("." + this.props.popoverNoSearchClassName), bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
  },

  showDestination: function (event) {
    event.preventDefault();
    event.stopPropagation();

    const titleDestination = event.target.parentNode.querySelector("." + this.props.titleDestinationDestSelector),
      titleLastSearch = event.target.parentNode.querySelector("." + this.props.titleLastSearchSelector);

    bcl.u.addClass(event.target, "hidden");

    titleLastSearch && bcl.u.addClass(titleLastSearch, "hidden");
    titleDestination && bcl.u.removeClass(titleDestination, "hidden");

    this.props.$submenuDestinationFields.allDestinations && bcl.u.removeClass(this.props.$submenuDestinationFields.allDestinations, "hidden");
    this.props.$lastSearch && bcl.u.addClass(this.props.$lastSearch, "hidden");
  },

  hideOrShowDestination: function (noSearch) {
    const parentHistory = this.props.$submenuDestinationFields.history.closest("." + this.props.popoverClassName),
      $destinationList = this.props.$submenuDestinationFields.allDestinations,
      $hotelsList = this.props.$submenuDestinationFields.hotels,
      noSearchElement = this.props.$submenuDestinationFields.noSearch,
      $searchTitle = this.searchNode(this.props.$destinationContainer, "titleLastSearchSelector"),
      $destinationTitle = this.searchNode(this.props.$destinationContainer, "titleDestinationDestSelector");

    bcl.u.addClass($searchTitle, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    bcl.u.addClass($destinationTitle, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

    if (noSearch) {
      bcl.u.addClass(parentHistory, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

      bcl.u.addClass($destinationList, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

      bcl.u.addClass($hotelsList, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

      bcl.u.removeClass($searchTitle, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

      bcl.u.forEach(noSearchElement, ($element) => {
        this.removeClassElement($element);
        this.insertTextOnElement($element);
      });
    } else {
      bcl.u.removeClass(parentHistory, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
      bcl.u.forEach(noSearchElement, ($element) => {
        this.addClassOnElement($element);
      });

      bcl.c.fastbooking.commonProps.fastbooking.lastSearchData.length <= 0 && bcl.u.removeClass($destinationList, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

      if (bcl.c.fastbooking.commonProps.fastbooking.lastSearchData.length <= 0) {
        bcl.u.addClass($searchTitle, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
        bcl.u.removeClass($destinationTitle, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
      }

      bcl.u.removeClass($hotelsList, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

      if (bcl.c.fastbooking.commonProps.fastbooking.lastSearchData.length > 0) {
        bcl.u.addClass($destinationTitle, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
        bcl.u.removeClass($searchTitle, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
      }
    }

    if (this.props.showTooltip) {
      this.showTooltip();
    } else {
      this.hideTooltip();
    }
  },

  sortHotelList: function ($listHotels, propToSort, minorFirst) {
    const listOfHotelsToSort = [],
      firstChild = $listHotels.firstElementChild;

    bcl.u.forEach($listHotels.children, function ($listItem) {
      $listItem.dataset.type !== "destination" && listOfHotelsToSort.push({ propToSort: parseInt($listItem.dataset[propToSort]), item: $listItem });
    });

    listOfHotelsToSort.sort((a, b) => (minorFirst ? a.propToSort - b.propToSort : b.propToSort - a.propToSort));

    $listHotels.innerHTML = "";

    $listHotels.appendChild(firstChild);

    bcl.u.forEach(listOfHotelsToSort, function (listItemObj) {
      $listHotels.appendChild(listItemObj.item);
    });
  },
  sortFBResortHotels: ($listHotels) => {
    const resorts = $listHotels?.querySelectorAll("[data-resort]");
    resorts?.forEach(($res) => {
      const selector = $res?.dataset?.resort;
      if (!selector) {
        return;
      }
      const $resortHotels = $listHotels.querySelectorAll(`[data-parent-resort=${selector}]`);
      if (!$resortHotels) {
        return;
      }
      let firstIndex = $res.dataset.index;
      let $firstElement;
      for (const $hotel of $resortHotels) {
        if ($hotel?.dataset?.index && firstIndex) {
          if (parseInt($hotel.dataset.index) >= parseInt(firstIndex)) {
            break;
          }
          firstIndex = $hotel.dataset.index;
          $firstElement = $hotel;
        }
      }
      if (firstIndex != $res.dataset.index && $firstElement) {
        $firstElement?.parentNode?.insertBefore($res, $firstElement);
      }
      for (let i = $resortHotels.length - 1; i >= 0; i--) {
        $res.parentNode?.insertBefore($resortHotels[i], $res.nextSibling);
      }
    });
  },
  sortFBHotelList: function ($listHotels) {
    const listOfHotelsToSort = [],
      percentageMatch = "percentageMatch";

    bcl.u.forEach($listHotels.children, function ($listItem) {
      listOfHotelsToSort.push({
        propToSort: parseInt($listItem.dataset[percentageMatch]),
        ranking: parseInt($listItem.dataset[bcl.c.fastbooking.commonProps.fastbooking.orderType]),
        item: $listItem,
        type: $listItem.dataset.type,
      });
    });

    listOfHotelsToSort.sort((a, b) => {
      if (a.type == "destination") {
        return -1;
      }

      if (b.type == "destination") {
        return 1;
      }

      if (a.propToSort != b.propToSort) {
        return b.propToSort - a.propToSort;
      }
      if (a.ranking && b.ranking) {
        return a.ranking - b.ranking;
      }
      return 0;
    });

    $listHotels.innerHTML = "";
    bcl.u.forEach(listOfHotelsToSort, function (listItemObj, i) {
      listItemObj.item.dataset.index = i;
      $listHotels.appendChild(listItemObj.item);
    });
  },

  destinationPrint: function (items, key, value, $listHotels, externalBrandKey) {
    const $listDestination = this.props.isSubmenuDestinationContainer ? this.props.$submenuDestinationFields.allDestinations : this.props.$submenuSearchFields["destination"];

    if (!$listDestination && !$listHotels) {
      return;
    }

    if (items.length !== 0) {
      bcl.u.removeClass($listDestination.closest("." + this.props.popoverClassName), bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    }

    if (!externalBrandKey) {
      $listDestination.innerHTML = "";
      $listHotels.innerHTML = "";
    }

    const accordionNode = this.props.accordionNodeCloned ?? this.props.$submenuSearchFields["destination"].parentElement?.querySelector("." + this.props.accordionItemClass),
      accordionNodeCloned = accordionNode.cloneNode(true);

    accordionNodeCloned && bcl.u.removeClass(accordionNodeCloned, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    this.props.accordionNodeCloned = accordionNodeCloned;

    const printDestinationNode = !externalBrandKey && (items.length != 1 ? items.length : Object.values(items[0].destinations.accordionItems).filter((a) => !a.hide).length) <= 1;
    bcl.u.forEach(items, (item) => {
      const itemObj = {
        parentItem: item.destinations,
        parentKey: item.key ?? this.props.accordionDefaultParentValue,
        countryName: item.destinations.title,
        itemKey: item.destinations.key,
        item: item.destinations,
        value: value,
        key: key,
        hide: item.destinations.hide,
        listHotels: $listHotels,
        listDestination: $listDestination,
        printDestinationNode: printDestinationNode,
        externalBrandKey: externalBrandKey,
      };
      this.addItemInList(itemObj);
    });

    this.sortFBHotelList($listHotels);
    this.sortFBResortHotels($listHotels);

    bcl.c.accordion.init($listDestination);
  },

  findContentList: function (list, parentKey) {
    let parentLabel = list?.querySelector(`[data-current-element='${parentKey}']`) ?? list?.querySelector(`[data-current-element='${this.props.accordionDefaultParentValue}']`),
      parentList = null;

    const parentContent = !parentLabel ? bcl.u.closest(list, "ul") : null,
      $submenu = this.props.isSubmenuDestinationContainer ? this.props.$submenuDestinationFields.allDestinations : this.props.$submenuSearchFields["destination"];

    if (parentContent) {
      parentLabel =
        parentContent.querySelector(`[data-current-element='${parentKey}']`) ?? parentContent.querySelector(`[data-current-element='${this.props.accordionDefaultParentValue}']`) ?? $submenu?.querySelector(`[data-current-element='${parentKey}']`);
    }

    parentList = bcl.u.closest(parentLabel, "." + this.props.accordionItemClass);

    return parentList?.querySelector(".accordion-content-JS");
  },

  addSubDestinationOrHotelInList: function ({ parentItem, parentKey, items, list, value, key, hide, listHotels, countryName, printDestinationNode, externalBrandKey }) {
    bcl.u.forEach(items, (subItem) => {
      const parentContentList = this.findContentList(list, parentKey);

      const hideValue = hide || subItem.hide || subItem[1]?.hide,
        itemObj = {
          parentItem: parentItem,
          parentKey: parentKey,
          item: key === "hotel" ? subItem : subItem[1],
          itemKey: key === "hotel" ? subItem.key : subItem[0],
          value: value,
          key: key,
          hide: parentItem.match ? false : hideValue,
          listHotels: listHotels,
          countryName: countryName,
          listDestination: key === "hotel" ? list : parentContentList,
          printDestinationNode: printDestinationNode,
          externalBrandKey,
        };
      if (this.props?.resorts?.length > 0) {
        const currentResort = this.props?.resorts?.find((r) => r?.selector == subItem?.key);
        if (key === "hotel") {
          if (currentResort) {
            itemObj.item.isResort = currentResort;
            itemObj.item.hotel.title = itemObj.item.label;
            itemObj.item.selector = currentResort.selector;
          } else {
            const currentId = subItem?.hotel?.id;
            if (currentId) {
              this.props.resorts.forEach((resort) => {
                if (resort?.hotels.includes(currentId)) {
                  itemObj.item.hotel.parentResort = resort.selector;
                }
              });
            }
          }
        }
      }
      this.addItemInList(itemObj);
    });
  },

  setEventsInElements: function (key, item, $node, hide, generateNodeSimple, obj, externalBrandKey) {
    if (key === "hotel" && item.featureExcerpt) {
      this.addItemInFeatureExcerpt($node, item, hide);
    }

    if (key === "hotel") {
      this.addClickInItem(
        $node,
        item,
        key,
        {
          countryName: obj.countryName,
          parentDestinationName: obj.parentItem.label,
        },
        externalBrandKey,
      );
    }

    if (generateNodeSimple) {
      this.addClickInAccordionItem($node, $node, key, obj, this.props.isSubmenuDestinationContainer);
    }

    if (!generateNodeSimple && key === "destination") {
      const divContainer = $node.querySelector("div .accordion-toggle-JS");
      this.addClickInAccordionItem(divContainer, $node, key, obj, this.props.isSubmenuDestinationContainer);
    }
  },

  addItemInList: function (obj) {
    const { parentKey, parentItem, item, itemKey, value, key, hide, listHotels, listDestination: list, countryName, printDestinationNode, externalBrandKey } = obj,
      label = this["getLabel" + key](item),
      generateNode = {
        hotel: bcl.s.searchHotel.generateNodeItemInList,
        destination: bcl.s.searchHotel.generateNodeItemInAccordionList,
      },
      generateNodeSimple = !!(key === "destination" && !item.accordionItems && !item.destinations && item.pages),
      $node = generateNode[key](key === "hotel" ? listHotels : list, value, label, null, null, {}, { hide, parentKey, currentItemKey: itemKey, currentItem: item, setSimple: generateNodeSimple });
    this.setEventsInElements(key, item, $node, hide, generateNodeSimple, obj, externalBrandKey);

    if (bcl.u.mobile.isMobile() && key === "destination" && list && list.children.length > 6 && !item.match) {
      bcl.u.addClass($node, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    }

    item.accordionItems &&
      this.addSubDestinationOrHotelInList({
        parentItem: item,
        parentKey: itemKey,
        items: Object.entries(item.accordionItems),
        list,
        value,
        key,
        hide,
        listHotels,
        countryName,
        printDestinationNode,
        externalBrandKey,
      });

    item.destinations &&
      this.addSubDestinationOrHotelInList({
        parentItem: item,
        parentKey: itemKey,
        items: Object.entries(item.destinations),
        list,
        value,
        key,
        hide,
        listHotels,
        countryName,
        printDestinationNode,
        externalBrandKey,
      });

    if (item.pages) {
      bcl.u.containsClass(listHotels.closest("." + this.props.popoverClassName), bcl.c.fastbooking.commonProps.fastbooking.hiddenClass) &&
        bcl.u.removeClass(listHotels.closest("." + this.props.popoverClassName), bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

      this.addSubDestinationOrHotelInList({
        parentItem: item,
        parentKey: itemKey,
        items: item.pages,
        list: list,
        value,
        key: "hotel",
        hide,
        listHotels: listHotels,
        countryName,
        printDestinationNode,
        externalBrandKey,
      });
    }

    key !== "hotel" && item.match && bcl.s.searchHotel.handlerAccordionUntilThisElement(list, obj, key);
    key === "hotel" &&
      item.match &&
      bcl.s.searchHotel.handlerAccordionUntilThisElement(
        list,
        {
          item: parentItem,
          itemKey: parentKey,
          value,
          listHotels,
          printDestinationNode,
        },
        "destination",
      );
  },

  addItemInFeatureExcerpt: function ($node, item, hide) {
    const $span = document.createElement("span");

    bcl.u.addClass($span, "c-ballon");
    bcl.u.addClass($span, "mod--blue");
    hide && bcl.u.addClass($node, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    $span.innerText = item.featureExcerpt;

    $node.appendChild($span);
  },

  initSuggestions: function () {
    const items = this.props.$destinationContainer.getElementsByClassName(this.props.suggestionsSelector);

    bcl.u.forEach(items, ($item) => {
      this.addClickInItem($item, { label: $item.innerText, selector: $item.dataset.selector }, null);
    });
  },

  addClickInItem: function ($node, item, key, countryData, externalBrandKey) {
    $node.addEventListener("click", () => {
      setTimeout(() => {
        this.clickInItem(item, key, countryData, externalBrandKey);
      }, 500);
    });
  },

  hideAllChildren: function (listHotels, keyException) {
    bcl.u.forEach(listHotels.children, function ($child) {
      !bcl.u.mobile.isMobile() && !bcl.u.containsClass($child, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass) && bcl.u.addClass($child, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);

      if (bcl.u.mobile.isMobile()) {
        const keyCurrentElement = $child.dataset.currentElement || $child?.querySelector("h3[data-current-element]").dataset.currentElement;
        keyCurrentElement !== keyException && !bcl.u.containsClass($child, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass) && bcl.u.addClass($child, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
        keyCurrentElement === keyException && bcl.u.removeClass($child, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
      }
    });
  },

  showChildren: function (allChildrenElements, listHotels, isHotels) {
    bcl.u.forEach(allChildrenElements, (childElement, index) => {
      if (!bcl.u.containsClass(childElement, this.props.accordionLabelClass)) {
        !bcl.u.mobile.isMobile() && bcl.u.containsClass(childElement, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass) && bcl.u.removeClass(childElement, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
        bcl.u.mobile.isMobile() && (index <= 6 || isHotels) && bcl.u.containsClass(childElement, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass) && bcl.u.removeClass(childElement, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
        this.handlerChildElements(childElement, childElement.dataset.currentElement, listHotels);
      }

      if (bcl.u.containsClass(childElement, this.props.accordionLabelClass)) {
        const $liElement = bcl.u.closest(childElement, "." + this.props.accordionItemClass);

        !bcl.u.mobile.isMobile() && bcl.u.containsClass($liElement, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass) && bcl.u.removeClass($liElement, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
        bcl.u.mobile.isMobile() && (index <= 6 || isHotels) && bcl.u.containsClass($liElement, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass) && bcl.u.removeClass($liElement, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
        this.handlerChildElements($liElement, childElement.dataset.currentElement, listHotels);
      }
    });
  },

  handlerChildElements: function ($liContainer, itemKey, listHotels) {
    const allChildrenElements = $liContainer.querySelectorAll(`[data-parent-element='${itemKey}']`).length ? $liContainer.querySelectorAll(`[data-parent-element='${itemKey}']`) : listHotels.querySelectorAll(`[data-parent-element='${itemKey}']`),
      isHotels = !$liContainer.querySelectorAll(`[data-parent-element='${itemKey}']`).length;

    allChildrenElements && this.showChildren(allChildrenElements, listHotels, isHotels);
  },

  removeBackgroundClass: function (list, classToRemove) {
    const itemsWithBackgroundGrey = list.querySelectorAll("." + classToRemove);

    bcl.u.forEach(itemsWithBackgroundGrey, (itemWithBackgroundGrey) => {
      bcl.u.removeClass(itemWithBackgroundGrey, classToRemove);
    });
  },

  recalculateBoldAndPercentageMatched: function (listHotels) {
    bcl.u.forEach(listHotels.children, (currentItem) => {
      const labelSplit = bcl.c.fastbooking.commonProps.destination.$destinationInput.value.split(" "),
        numberHotelLabel = currentItem.innerHTML.split(" - ")[1],
        matched = false;

      let title = currentItem.innerText.split(" - ")[0];

      const { title: titleBold } = bcl.s.searchHotel.handlerBold(labelSplit, title, matched);
      title = titleBold;

      currentItem.innerHTML = numberHotelLabel && numberHotelLabel != "undefined" ? title + " - " + numberHotelLabel : title;

      const percentageMatched = bcl.c.fastbooking.commonProps.destination.$destinationInput.value ? bcl.s.searchHotel.getPercentageOfMatch(currentItem.innerText.split(".")[0], bcl.c.fastbooking.commonProps.destination.$destinationInput.value) : 0;
      currentItem.dataset.percentageMatch = percentageMatched.toString();
    });
  },

  addClickInAccordionItem: function ($node, $liContainer, key, { item, itemKey, listHotels, parentKey, value, listDestination, countryName, parentItem }, isSubmenuDestinationContainer) {
    $node.addEventListener("click", () => {
      setTimeout(() => {
        bcl.c.fastbooking.commonProps.destination.$destinationInput.value = this.getLabelByType(key, item);
        bcl.c.fastbooking.commonProps.destination.$destinationInput.setAttribute("value", bcl.c.fastbooking.commonProps.destination.$destinationInput.value);

        const destinationList = isSubmenuDestinationContainer ? this.props.$submenuDestinationFields.allDestinations : this.props.$submenuSearchFields.destination,
          $containerActive = isSubmenuDestinationContainer ? this.props.$destinationContainer : this.props.$searchContainer;

        this.removeBackgroundClass(destinationList, "mod--background-grey");

        bcl.u.addClass($node, "mod--background-grey");

        this.hideAllChildren(listHotels);
        this.handlerChildElements($liContainer, itemKey, listHotels);

        bcl.u.removeClass($containerActive, "mod--input-search");

        if (bcl.u.mobile.isMobile()) {
          const parentElement = destinationList.querySelector(`[data-current-element='${parentKey}']`) || destinationList,
            listToHide = bcl.u.closest(parentElement, "li")?.querySelector("ul") || parentElement;
          bcl.u.addClass($containerActive, "mod--input-search");

          this.hideAllChildren(listToHide, itemKey);
          bcl.s.searchHotel.handlerAccordionUntilThisElement(
            destinationList,
            {
              item,
              itemKey,
              listHotels,
              parentKey,
              value,
              listDestination,
            },
            key,
          );
        }

        bcl.s.searchHotel.createFirstElementInHotels(key, item, this.props.$ownHotelList, value, parentKey, itemKey);
        this.recalculateBoldAndPercentageMatched(listHotels);
        !isSubmenuDestinationContainer && this.sortHotelList(listHotels, "percentageMatch");

        this.updateData({
          key: key,
          item: item,
          countryData: { countryName: countryName, parentDestinationName: parentItem.label },
        });

        bcl.c.fastbooking.calendar.updateDataDest(bcl.c.fastbooking.commonProps.destination.data);
        bcl.c.fastbooking.rooms.updateDataDest(bcl.c.fastbooking.commonProps.destination.data);
        bcl.c.fastbooking.discount.updateDataDest(bcl.c.fastbooking.commonProps.destination.data);

        this.initFacets();
      }, 500);
    });
  },

  clickInItem: function (item, key, countryData) {
    if (!item.externalBrandHotel) {
      bcl.c.fastbooking.calendar.correctCalendarDates(false);
    } else {
      this.props.used = true;
    }
    bcl.c.fastbooking.commonProps.destination.$destinationInput.value = this.getLabelByType(key, item);
    bcl.c.fastbooking.commonProps.destination.$destinationInput.setAttribute("value", bcl.c.fastbooking.commonProps.destination.$destinationInput.value);

    bcl.c.fastbooking.isResort(event) && this.populeWizardButtonWhenIsResort(item);

    this.processClick({
      key: key,
      item: item,
      countryData: countryData,
    });
  },
  destinationWasClicked: (obj) => {
    if (obj?.groupItems?.isResort || obj?.destination?.groupItems?.isResort || obj?.item?.externalBrandHotel || obj?.isExternalBrandHotel) {
      return true;
    }
    if (obj?.key) {
      return obj.key !== "hotel";
    }
    if (obj?.type) {
      return obj.type !== "hotel";
    }
    if (obj?.destination?.type) {
      return obj.destination.type !== "hotel";
    }
    return false;
  },
  processClick: function (obj) {
    bcl.c.fastbooking.commonProps.calendar.destinationWasClicked = this.destinationWasClicked(obj);
    this.clean(obj);

    this.close();

    this.updateData(obj);

    bcl.c.fastbooking.calendar.cleanCalendar();
    bcl.c.fastbooking.commonProps.calendar.dataOffer = null;

    bcl.c.fastbooking.discount.cleanCheckbox();

    bcl.c.fastbooking.calendar.updateDataDest(bcl.c.fastbooking.commonProps.destination.data);
    bcl.c.fastbooking.rooms.updateDataDest(bcl.c.fastbooking.commonProps.destination.data);
    bcl.c.fastbooking.discount.updateDataDest(bcl.c.fastbooking.commonProps.destination.data);
    !bcl.c.fastbooking.commonProps.calendar.hideDeleteHotelOption && bcl.u.addClass(bcl.c.fastbooking.commonProps.calendar.$parentDestination, bcl.c.fastbooking.commonProps.calendar.activeDateClass);
    bcl.c.fastbooking.rooms.loadOccupancy();
  },

  clean: function (data) {
    if (data?.item?.hotel && data.item.hotel.id) {
      bcl.c.fastbooking.commonProps.destination.used = false;
    }
  },

  close: function () {
    if (!this.props.used) {
      bcl.s.tabs.openNext();
      bcl.c.fastbooking.commonProps.destination.used = true;
    } else {
      bcl.s.tabs.closeActive();
    }
  },

  closeSearch: function () {
    bcl.c.fastbooking.commonProps.destination.$destinationInput.value = bcl.c.fastbooking.commonProps.destination.lastLabel || "";
    bcl.c.fastbooking.commonProps.destination.$destinationInput.setAttribute("value", bcl.c.fastbooking.commonProps.destination.$destinationInput.value);

    if (bcl.c.fastbooking.commonProps.destination.$destinationInput.value === "") {
      this.props.containerActive = null;
      bcl.u.removeClass(this.props.$containerActive, bcl.s.tabs.props.classItemMultiple);
    }
  },

  updateData: function (obj) {
    if (obj.key === "hotel" && !obj?.item?.isResort) {
      bcl.c.fastbooking.commonProps.destination.data = {
        type: "hotel",
        id: obj.item.hotel.id,
        data: obj.item || {},
        countryData: obj.countryData,
        label: bcl.c.fastbooking.commonProps.destination.lastLabel,
        isExternalBrandHotel: obj.item.externalBrandHotel,
      };
    } else {
      bcl.c.fastbooking.commonProps.destination.data = {
        type: "group",
        id: obj.item.selector,
        groupItems: obj.item,
        data: {},
        label: bcl.c.fastbooking.commonProps.destination.lastLabel,
      };
    }
  },

  updateItem: function (obj) {
    bcl.c.fastbooking.commonProps.destination.used = true;

    this.close();

    bcl.c.fastbooking.commonProps.destination.$destinationInput.value = obj.label || "";
    bcl.c.fastbooking.commonProps.destination.$destinationInput.setAttribute("value", bcl.c.fastbooking.commonProps.destination.$destinationInput.value);
    !bcl.c.fastbooking.commonProps.calendar.hideDeleteHotelOption && bcl.u.addClass(bcl.c.fastbooking.commonProps.calendar.$parentDestination, bcl.c.fastbooking.commonProps.calendar.activeDateClass);

    bcl.c.fastbooking.commonProps.destination.lastLabel = obj.label || "";
    bcl.c.fastbooking.commonProps.destination.data = obj;
    bcl.c.fastbooking.calendar.updateDataDest(obj);
    bcl.c.fastbooking.rooms.updateDataDest(obj);
    bcl.c.fastbooking.discount.updateDataDest(obj);
  },

  cleanDestination: function () {
    bcl.c.fastbooking.commonProps.destination.$destinationInput.value = "";
    bcl.c.fastbooking.commonProps.destination.$destinationInput.setAttribute("value", bcl.c.fastbooking.commonProps.destination.$destinationInput.value);

    bcl.c.fastbooking.commonProps.destination.lastLabel = "";
    bcl.c.fastbooking.commonProps.destination.data = null;
  },

  getLabelByType: function (key, item) {
    const label = key !== "hotel" ? (item.label ?? item.title) : item.hotel.title;
    if (key !== "hotel" || (key === "hotel" && item.isResort)) {
      bcl.c.fastbooking.commonProps.destination.lastLabel = item.label ?? item.title;
    } else {
      bcl.c.fastbooking.commonProps.destination.lastLabel = item.hotelPublicName || item.label;
    }
    return label;
  },

  getParseLabelHotel: function (item) {
    const label = item.hotel.title;

    return label.split(",")[0];
  },

  getLabelhotel: function (item) {
    return item.label;
  },

  getLabelFromDestination: function (item) {
    return item.title;
  },

  getLabeltematic: function (item) {
    return item.label + ' - <span class="c-fastbooking__submenu-search-destination-list mod--blue">' + item.count + " " + this.props.hotelsLabel + "</span>";
  },

  getLabeldestination: function (item) {
    return (item.title || item.label) + ' <span class="hidden all-label-JS"></span> - <span class="c-fastbooking__submenu-search-destination-list mod--blue hotels-count-JS">' + item.count + " " + this.props.hotelsLabel + "</span>";
  },

  getLabelexperience: function (item) {
    return item.label + ' - <span class="c-fastbooking__submenu-search-destination-list mod--blue">' + item.count + " " + this.props.hotelsLabel + "</span>";
  },

  populeWizardButtonWhenIsResort: function (item) {
    const wizardButton = document.querySelector(".booking-button-JS");
    if (item && wizardButton) {
      wizardButton.dataset.hotel = item.hotel.id;
      wizardButton.dataset.searchtitle = item.hotelPublicName;
    }
  },
};

export default destination;
